var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarnMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accelerate",
    transform: "translate(-10.000000, -29.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "BG-Circle",
    fill: "#EDEFF3",
    fillRule: "nonzero",
    cx: 49.1248,
    cy: 71.1248,
    r: 39.1248
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5941184,78.3962752 C36.1377984,78.3962752 41.5536851,83.7130152 41.7163006,90.2210174 L41.7200608,90.5222176 L41.7163476,90.8225427 C41.5903559,95.9164184 38.2687601,100.499925 33.377735,102.059884 L27.6007732,103.802101 C23.0179153,100.777347 19.1088581,96.814376 16.147168,92.1867534 L17.9665024,86.867824 C19.432732,81.980392 23.9348088,78.5309929 29.1221021,78.4001312 L29.5941184,78.3962752 Z",
    id: "Exhaust",
    fill: "#D4DCE6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6999776,87.9981545 C51.8526976,86.5031753 62.317552,82.3504553 71.453536,73.0483625 C93.2137888,51.4542185 91.5527008,29.0295305 91.5527008,29.0295305 C91.5527008,29.0295305 69.2941216,27.3684425 47.5338688,48.9625865 C35.740144,60.7563113 34.079056,68.7295337 32.5840768,72.7161449 L47.6999776,87.9981545 Z",
    id: "Color",
    fill: "#FF4D5B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Window",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 67.6330336,
    cy: 53.1153065,
    r: 6.9765696
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9780216,78.7205244 L65.1414016,84.1776521 C65.1414016,86.1709577 64.4769664,87.9981545 63.3142048,89.4931337 L52.0188064,102.44962 L47.6999776,87.9981545 L48.765119,87.6055076 L49.2723597,87.4115894 C52.8563642,86.0249708 58.8209169,83.3657748 64.9780216,78.7205244 Z M55.0287717,65.2700636 L55.1748736,65.4073577 C56.503744,66.7362281 56.503744,69.0617513 55.1748736,70.3906217 L36.4045792,86.6692841 L33.9129472,84.1776521 L50.1916096,65.4073577 C51.4255607,64.1734066 53.5188706,64.0852672 54.8755872,65.1429396 L55.0287717,65.2700636 Z M36.4045792,55.4408297 L41.5806229,55.5956692 C35.0805929,63.7938944 33.7792519,69.5290114 32.5840768,72.7161449 L32.9106112,73.0458297 L18.1326112,68.5634249 L31.0890976,57.2680265 C32.4961368,56.1736626 34.1974588,55.5207228 36.0545775,55.4476931 L36.4045792,55.4408297 Z",
    id: "Fins",
    fill: "#000F38",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnMore);
export default __webpack_public_path__ + "static/media/earn-more.cfde3fc57990ada60138f49f1b7f47c7.svg";
export { ForwardRef as ReactComponent };